import * as authentication from "../../common/actions/authentication";
import * as productLists from "../actions/productLists.js";

import Immutable from "seamless-immutable";
import {postFix} from "../../common/util/changeUtils.jsx";

const defaultState = () => {
    return Immutable({
        campaignProductsLoading: false,
        newProductsLoading: false,
        boughtProductsLoading: false,
        customListsLoading: false,
        customListUploading: false,
        customListDownloadingPdf: false,
        customListsSorting: false,
        campaignProducts: [],
        newProducts: [],
        boughtProducts: [],
        customLists: [],
        campaigns:[],
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case productLists.LOADING_CAMPAIGN:
        return state.merge({
            campaignProductsLoading: action.loading,
        }, {
            deep: true
        });
    case productLists.SET_CAMPAIGN_PRODUCTS:
        return state.merge({
            campaignProducts: action.products
        }, {
            deep: true
        });
    case productLists.SET_CAMPAIGNS:
        return state.merge({
            campaigns: [
                ...action.campaigns,
            ]
        }, {
            deep: true
        });
    case productLists.SET_CAMPAIGN_PRODUCT_IMAGE_URL:
        return state.merge({
            campaignProducts: Immutable(state.campaignProducts).map(function(obj, index) {
                return (index === action.index) ? {
                    ...obj,
                    product: {
                        ...obj.product,
                        imageUrl:action.imageUrl
                    }
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.LOADING_NEW_PRODUCTS:
        return state.merge({
            newProductsLoading: action.loading,
        }, {
            deep: true
        });
    case productLists.SET_NEW_PRODUCTS:
        return state.merge({
            newProducts: action.products
        }, {
            deep: true
        });
    case productLists.SET_NEW_PRODUCT_IMAGE_URL:
        return state.merge({
            newProducts: Immutable(state.newProducts).map(function(obj, index) {
                return (index === action.index) ? {
                    ...obj,
                    product: {
                        ...obj.product,
                        imageUrl:action.imageUrl
                    }
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.LOADING_BOUGHT_PRODUCTS:
        return state.merge({
            boughtProductsLoading: action.loading,
        }, {
            deep: true
        });
    case productLists.SET_BOUGHT_PRODUCTS:
        return state.merge({
            boughtProducts: action.products
        }, {
            deep: true
        });
    case productLists.LOADING_MY_LISTS:
        return state.merge({
            customListsLoading: action.loading,
        }, {
            deep: true
        });
    case productLists.UPLOADING_MY_LIST:
        return state.merge({
            customListUploading: action.uploading,
        }, {
            deep: true
        });
    case productLists.DOWNLOADING_MY_LIST_PDF:
        return state.merge({
            customListDownloadingPdf: action.downloading,
        }, {
            deep: true
        });
    case productLists.SET_MY_LISTS:
        return state.merge({
            customLists: [
                ...action.lists,
                {
                    myListId: -1,
                    name: "",
                    lines: [],
                    [`lines${postFix}`]: [],
                }
            ]
        }, {
            deep: true
        });
    case productLists.SET_MY_LIST_PRODUCT_IMAGE_URL:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj, index) {
                return (index === action.listIndex) ? {
                    ...obj,
                    lines: Immutable(obj.lines).map(function(obj, index) {
                        return (index === action.itemIndex) ? {
                            ...obj,
                            product: {
                                ...obj.product,
                                imageUrl: action.imageUrl,
                            }
                        } : obj;
                    }),
                    [`lines${postFix}`]: Immutable(obj[`lines${postFix}`]).map(function(obj, index) {
                        return (index === action.itemIndex) ? {
                            ...obj,
                            product: {
                                ...obj.product,
                                imageUrl: action.imageUrl,
                            }
                        } : obj;
                    }),
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.SWAP_REPLACEMENT_IN_MY_LIST:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                return (obj.myListId === action.listId) ? {
                    ...obj,
                    [`lines${postFix}`]: Immutable(obj[`lines${postFix}`]).map(function(obj) {
                        return (obj.productId === action.replacedProductId) ? {
                            ...obj,
                            productId: action.replacementProductId,
                            replacedProduct: null,
                            product: {
                                ...obj.replacedProduct,
                            }
                        } : obj;
                    }),
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.EDIT_MY_LIST:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                return (obj.myListId === action.listId) ? {
                    ...obj,
                    ...action.change,
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.ADD_TO_MY_LISTS:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                return (obj.myListId === action.listId) ? {
                    ...obj,
                    [`lines${postFix}`]: obj[`lines${postFix}`].some((ele) => ele.productId===action.item.productId) ? obj[`lines${postFix}`] :
                        obj[`lines${postFix}`].concat({
                            ...action.item,
                        }),
                } : obj;
            })
        }, {
            deep: true
        });
    case productLists.ADD_NEW_MYLIST:
        return state.merge({
            customLists: state.customLists.concat(action.listItem)
        }, {
            deep: true
        });
    case productLists.REMOVE_FROM_MY_LISTS:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                return (obj.myListId === action.listId) ? {
                    ...obj,
                    [`lines${postFix}`]: obj[`lines${postFix}`].filter((ele) => ele.productId!==action.productId)
                } : obj;
            }),
        }, {
            deep: true
        });
    case productLists.DELETE_MYLIST:
        return state.merge({
            customLists: Immutable(state.customLists).filter((ele) => ele.myListId!==action.myListId),
        }, {
            deep: true
        });
    case productLists.MOVE_FROM_TO_MY_LIST:
    {
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                if(obj.myListId === action.listId){
                    const arr = Immutable.asMutable(obj[`lines${postFix}`]);
                    const itemToMove = arr[action.index1];
                    arr.splice(action.index1,1);
                    arr.splice(action.index2,0,itemToMove);
                    return {
                        ...obj,
                        [`lines${postFix}`]: arr,
                    };
                } else {
                    return obj;
                }
            })
        }, {
            deep: true
        });
    }
    case productLists.SET_SORTING_MY_LISTS:
        return state.merge({
            customListsSorting: action.sorting,
        }, {
            deep: true
        });
    case productLists.SORT_MY_LISTS:
    {
        const arr = Immutable.asMutable(state.customLists);
        const itemToMove = arr[action.index1];
        arr.splice(action.index1,1);
        arr.splice(action.index2,0,itemToMove);

        return Immutable.setIn(state, ["customLists"], arr);
    }
    case productLists.FIX_CHANGES_MYLIST:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                if(obj.myListId === action.listId){
                    return {
                        ...obj,
                        name: obj[`name${postFix}`] ? obj[`name${postFix}`] : obj.name,
                        lines: obj[`lines${postFix}`] ? obj[`lines${postFix}`] : obj.lines,
                    };
                } else {
                    return obj;
                }
            })
        }, {
            deep: true
        });
    case productLists.CLEAR_CHANGES_MYLIST:
        return state.merge({
            customLists: Immutable(state.customLists).map(function(obj) {
                return {
                    ...obj,
                    [`name${postFix}`]: obj.name,
                    [`lines${postFix}`]: obj.lines,
                };
            })
        }, {
            deep: true
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}